import { BaseService } from '@/modules/Core/services/BaseService' // Asegúrate de tener la interfaz definida

import type {
  IConfInteroperabilidad
} from '@/modules/Admision/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseRDABody, IValidacionRdaBody } from '@/modules/Core/interfaces/IInteroperabilidad'
import type { IResponseApi } from '@/modules/Core/interfaces'
export class InteroperabilidadService extends BaseService<IConfInteroperabilidad> {
  constructor () {
    super({
      baseUrl: 'scheduling/interoperability/'
    })
  }
  async validarRDA (
    cittId: number
  ): Promise<AxiosResponse<IResponseApi<IValidacionRdaBody>>> {
    return this.http.post<IResponseApi<IValidacionRdaBody>>(`validar-rda`, { cittId }).catch(this.errorHandle)
  }

  async enviarRDA (
    ciadId:number,
    cittId:number
  ):Promise<AxiosResponse<IResponseApi<IResponseRDABody>>>{
    return this.http.post<IResponseApi<IResponseRDABody>>(`sendRDAPatient`, { ciadId, cittId }).catch(this.errorHandle)
  }
  async consultarPacienteSimilar (
    data: {tipoIdentificacion: string, identificacion: string}
  ):Promise<AxiosResponse<IResponseApi<unknown>>>{
    return this.http.post<IResponseApi<unknown>>(`consultarPacienteSimilar`, data).catch(this.errorHandle)
  }

  async resolveReferences (
    references: string[]
  ):Promise<AxiosResponse<IResponseApi<unknown[]>>>{
    return this.http.post<IResponseApi<unknown[]>>(`resolveReferences`, { references }).catch(this.errorHandle)
  }
  async listarRdasComposition (
    data: {tipoIdentificacion: string, identificacion: string}
  ):Promise<AxiosResponse<IResponseApi<unknown>>>{
    return this.http.post<IResponseApi<unknown>>(`listar-rdas-composition`, data).catch(this.errorHandle)
  }
  async consultarRdaPorIdComposition (
    rdaId: string
  ):Promise<AxiosResponse<IResponseApi<unknown>>>{
    return this.http.get<IResponseApi<unknown>>(`consultar-rda-por-id-composition/${rdaId}`).catch(this.errorHandle)
  }
  async paginationSearch (
    linkParams: string
  ):Promise<AxiosResponse<IResponseApi<unknown>>>{
    return this.http.get<IResponseApi<unknown>>(`pagination?${linkParams}`).catch(this.errorHandle)
  }
}
